import React from "react";
import { Outlet, Navigate } from "react-router-dom";
const Protected = () => {
  const auth = localStorage.getItem("token");
  return <div>{auth ? <Outlet /> : <Navigate to="/" />}</div>;
};

export default Protected;
